<template>
  <div style="min-height: 400px;">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="first"></el-tab-pane>
      <el-tab-pane label="待审核" name="second"></el-tab-pane>
      <el-tab-pane label="已通过" name="third"></el-tab-pane>
      <el-tab-pane label="已拒绝" name="fourth"></el-tab-pane>
      <el-tab-pane label="已辞退" name="delet"></el-tab-pane>
    </el-tabs> -->
    <el-table :data="adminTbaleData" style="width: 100%">
      <!-- <el-table-column label="圈子ID" prop="circleId" width="80" align="center">
      </el-table-column> -->

      <el-table-column label="圈子昵称" width="140" align="center">
        <template slot-scope="scope">
          <span>{{ circleData.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="用户ID" prop="userId" width="80" align="center">
      </el-table-column>

      <el-table-column label="用户昵称" prop="userName" width="160" align="center">
      </el-table-column>

      <el-table-column label="用户头像" width="100" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.userPicture" style="width: 50px; height: 50px;border-radius: 50%;"
            fit="cover"></el-image>
        </template>
      </el-table-column>

      <el-table-column label="管理类型" prop="type" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.type == 0 ? '管理员' : '圈主' }}
        </template>
      </el-table-column>

      <el-table-column label="申请时间" prop="AddTime" width="160" align="center">
      </el-table-column>

      <el-table-column label="申请原因" show-overflow-tooltip width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.reason_application ? scope.row.reason_application : '--' }}
        </template>
      </el-table-column>

      <el-table-column label="审核状态" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.auditStatus == 0 ? '待审核' : scope.row.auditStatus == 1 ? '已通过' : scope.row.auditStatus
            == 2
            ? '已拒绝' : '已辞退' }}
        </template>
      </el-table-column>

      <el-table-column label="审核时间" show-overflow-tooltip width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.AuditTime ? scope.row.AuditTime : '--' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            操作
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="text-align: right;margin-top: 10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="currenChange" :current-page.sync="params.pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize" layout="total, sizes, prev, pager, next"
        :total="total_pages">
      </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" :append-to-body="true" width="30%" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="请选择" prop="region">
          <el-select v-model="ruleForm.region" placeholder="请选择是否通过">
            <el-option label="通过" :value="1"></el-option>
            <el-option label="拒绝" :value="2"></el-option>
            <el-option label="辞退" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.region !== 1 && ruleForm.region" label="拒绝理由" prop="refuseVal">
          <el-input v-model="ruleForm.refuseVal"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSetadminFn('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCircleAdminApi, auditCircleAdminApi } from '@/api/circle'
export default {
  created() {
    this.getDataFn()
  },
  computed: {
    circleData() {
      return this.$store.state.circleData
    }
  },
  data() {
    return {
      params: {
        circleId: '',
        pageNum: 1,
        pageSize: 10
      },
      adminTbaleData: [],
      centerDialogVisible: false,
      nowAdminVal: '',
      ruleForm: {
        region: '',
        refuseVal: ''
      },
      rules: {
        region: [{ required: true, message: '请选择审核结果', trigger: 'blur' }],
        refuseVal: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }]
      },
      total_pages: 1,
      activeName: 'first',
    }
  },
  methods: {
    getDataFn() {
      const that = this;
      that.params.circleId = that.circleData.circleId
      getCircleAdminApi(that.params).then(res => {
        if (res.code == 200) {
          that.adminTbaleData = res.data.records
          that.total_pages = res.data.total
        } else {
          that.$message.error(res.msg)
        }
      })
    },
    // 分页被单击
    async currenChange(pages) {
      this.params.pageNum = pages
      this.getDataFn()
    },
    handleEdit(index, row) {
      console.log(index, row)
      this.centerDialogVisible = true
      this.nowAdminVal = row
    },
    // （0=待审核 1=已通过 2=已拒绝 3=辞退）
    submitSetadminFn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          auditCircleAdminApi()
        } else {
          this.$message.error('请填写拒绝理由')
          return false
        }
      })
    },
    handleSizeChange(size) {
      this.params.pageSize = size
      this.params.pageNum = 1 // 切换页大小时重置页码为1
      this.getDataFn()
    }
  }
}
</script>

<style></style>
